/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, useRef } from "react";
import Logo from "./Logo";
import DropDown from "./DropDown";
import Notification from "../../ExtraComponents/Notification";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TRADING_OFF_USER } from "../../../ReduxStore/Slice/Users/DashboardSlice";
import {
  User_Profile,
  GET_MESSAGE_BRODS,
} from "../../../ReduxStore/Slice/Common/commoSlice.jsx";
import { GET_HELPS } from "../../../ReduxStore/Slice/Admin/AdminHelpSlice";
import { Log_Out_User } from "../../../ReduxStore/Slice/Auth/AuthSlice";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";

import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";
import Chatbot from "../Chatbot.jsx";
import GlobalBugReportModal from "../../../layout/Common/GlobalBugReportModal.jsx";
import html2canvas from "html2canvas";
import { io } from "socket.io-client";
import {
  BrokerProfile_Info,
  DeltaBrokerProfile_Info,
  BinanceBrokerProfile_Info,
  ZebPayBrokerProfile_Info,
  Broker_Coinswitch_Wallet,
} from "../../../ReduxStore/Slice/BrokerSlice/BrokerSlice";
import { socket_url } from "../../../Utils/Config.jsx";

const Header = ({ ChatBox }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [UserDetails, setUserDetails] = useState([]);
  const [getAllClients, setAllClients] = useState({ loading: true, data: [] });
  const [messageData, SetMessageData] = useState({ loading: true, data: [] });
  const [showChat, setShowChat] = useState(false);
  const [isBugModalOpen, setIsBugModalOpen] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [isCapturing, setIsCapturing] = useState(false);
  const pollingIntervalRef = useRef(null);

  const [avatar, setAvatar] = useState(
    () =>
      localStorage.getItem("selectedAvatar") ||
      "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
  );

  // Get user details from localStorage
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const page = localStorage.getItem("page");
  const routePath = localStorage.getItem("route");
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const user_role = JSON.parse(localStorage.getItem("user_role"));
  const UserNamego_localstg = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );

  // const socket = io(socket_url, {
  //   path: "/node/socket.io/",
  // });
  // socket.on("connect", () => {
  // });
  // socket.on("connect_error", (err) => {
  //   console.error("❌ Socket connection error:", err.message);
  // });

  // socket.on("disconnect", (reason) => {
  //   console.warn("⚠️ Socket disconnected:", reason);
  // });

  // socket.on("clientStatus", async (data) => {
  //   if (user_details?.user_id === data?.user_Id) {
  //     const request = {
  //       userId: user_details.user_id,
  //       Device: "web",
  //     };
  //     await dispatch(Log_Out_User(request));
  //     localStorage.clear();
  //     navigate("/");
  //   }
  // });

  // socket.on("adminhelpMessage", async (data) => {
  //   if (user_role === "ADMIN") {
  //     Notfication();
  //   }
  // });

  // socket.on("brodcastMessage", async (data) => {
  //   if (
  //     user_details.Role === "USER" &&
  //     user_details.broker === data.broker_id
  //   ) {
  //     message_brod();
  //   }
  // });

  useEffect(() => {
    if (user_role === "ADMIN") {
      Notfication();
    }
  }, []);

  useEffect(() => {
    ClearSession();
  }, []);

  useEffect(() => {
    fetchUserProfile();
    message_brod();

    startStatusPolling();
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, []);

  const handleRaiseTicket = async () => {
    setIsCapturing(true);
    try {
      // Capture the full documentElement to fix white/blank screen issues
      const canvas = await html2canvas(document.documentElement, { 
        useCORS: true, 
        allowTaint: true,
        logging: false,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
        scrollX: window.scrollX,
        scrollY: window.scrollY
      });
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], `screenshot_${new Date().getTime()}.png`, { type: 'image/png' });
          setCapturedImage(file);
        }
        setIsBugModalOpen(true);
        setIsCapturing(false);
      }, 'image/png');
    } catch (e) {
      console.error("Screenshot capture failed:", e);
      setCapturedImage(null);
      setIsBugModalOpen(true);
      setIsCapturing(false);
    }
  };

  const handleAvatarChange = (newAvatarUrl) => {
    localStorage.setItem("selectedAvatar", newAvatarUrl);
    setAvatar(newAvatarUrl);
    window.location.reload();
  };

  // Fetch user profile
  const fetchUserProfile = async () => {
    try {
      const userId = gotodashboard
        ? UserNamego_localstg.user_id
        : user_details.user_id;
      const token = gotodashboard
        ? UserNamego_localstg.token
        : user_details.token;

      const response = await dispatch(
        User_Profile({ id: userId, token: token })
      ).unwrap();

      if (response.status) {
        if (response.data[0].ActiveStatus === "0") {
          localStorage.clear();
          window.location.reload();
        }

        localStorage.setItem("client_key", response.data[0].client_key);
        localStorage.setItem("selectedAvatar", response.data[0]?.profileimg);

        localStorage.setItem(
          "backtestPermission",
          response.data[0]?.backtestPermission
        );
        localStorage.setItem("Trading_status", response.data[0].TradingStatus)

        setUserDetails(response.data[0]);
      } else {
        if (
          (response.msg === "Unauthorized!" ||
            response.msg === "No token provided!!") &&
          !gotodashboard
        ) {
          localStorage.clear();
          window.location.reload();
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  useEffect(() => {
    if (user_details.Role === "USER") {
      // const handleNewMessage = (data) => {
      //   if (data.broker_id === user_details.broker || data.broker_id === "-1") {
      //     message_brod();
      //   }
      // };
      // // 👉 listener add
      // // socket.on("newMessage", handleNewMessage);
      // // 👉 cleanup function
      // return () => {
      //   socket.off("newMessage", handleNewMessage);
      // };
    }
  }, [user_details?.broker, user_details?.Role]);

  // Get message broadcasts
  const message_brod = async () => {
    if (user_details.Role === "USER") {
      try {
        const response = await dispatch(
          GET_MESSAGE_BRODS({ id: user_details.user_id })
        ).unwrap();
        if (response.status) {
          SetMessageData({ loading: false, data: response.data });
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    }
  };

  // Show notifications for admin
  const Notfication = async () => {
    if (user_role === "ADMIN") {
      try {
        const response = await dispatch(
          GET_HELPS({
            user_id: user_details.user_id,
            token: user_details.token,
          })
        ).unwrap();

        setAllClients({
          loading: false,
          data: response.data || [],
        });
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setAllClients({ loading: false, data: [] });
      }
    }
  };

  // Clear session if token expired
  const ClearSession = async () => {
    try {
      const decoded = jwt_decode(user_details.token);

      if (decoded.exp * 1000 < new Date().getTime()) {
        const request = {
          userId: user_details.user_id,
          Device: "web",
        };

        await dispatch(Log_Out_User(request));
        localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      console.error("Error clearing session:", error);
      localStorage.clear();
      navigate("/");
    }
  };

  // Trading status toggle
  const Trading_status_off = (TradingStatus) => {
    if (TradingStatus === "1") {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to turn off trading status?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, turn it off!",
      }).then((result) => {
        if (result.isConfirmed) {
          const data = {
            user_id: user_details?.user_id,
            device: "",
            network_ip: "",
            token: user_details?.token,
          };

          dispatch(TRADING_OFF_USER(data))
            .unwrap()
            .then((response) => {
              if (response.status) {

                Swal.fire({
                  icon: "success",
                  title: "Trading status turned off.",
                  showConfirmButton: false,

                  timer: 3000,
                });
                fetchUserProfile();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Failed to update trading status.",
                  showConfirmButton: true,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: "Something went wrong.",
                confirmButtonColor: "#d33",
              });
              console.error("Error updating trading status:", error);
            });
        }
      });
    } else {

      const data = {
        _id: user_details?.user_id,
        api_secret: UserDetails.api_secret,
        api_key: UserDetails.api_key,
      };

      if (UserDetails?.broker === "1") {
        dispatch(BrokerProfile_Info(data))
          .unwrap()
          .then((data) => {
            if (data.status) {
              Swal.fire({
                title: "Success!",
                text: "Broker connected successfully.",
                icon: "success",
                confirmButtonText: "OK",
                timer: "3000",
              });
              fetchUserProfile();
            } else {
              Swal.fire({
                title: "Error!",
                text: "Failed to connect broker. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
              });
              navigate("/client/apicreateinfo");
            }
          })
          .catch((err) => {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong while connecting broker.",
              icon: "error",
              confirmButtonText: "OK",
            });
            navigate("/client/apicreateinfo");
          });
      } else if (UserDetails?.broker === "2") {
        dispatch(DeltaBrokerProfile_Info(data))
          .unwrap()
          .then((data) => {
            if (data.status) {
              Swal.fire({
                title: "Success!",
                text: "Broker connected successfully.",
                icon: "success",
                confirmButtonText: "OK",
                timer: "3000",
              });
              fetchUserProfile();
            }
          })
          .catch((err) => {
            navigate("/client/apicreateinfo");
          });
      } else if (UserDetails?.broker === "3") {
        dispatch(BinanceBrokerProfile_Info(data))
          .unwrap()
          .then((data) => {
            if (data.status) {
              Swal.fire({
                title: "Success!",
                text: "Broker connected successfully.",
                icon: "success",
                confirmButtonText: "OK",
                timer: "3000",
              });
              fetchUserProfile();
            }
          })
          .catch((err) => {
            navigate("/client/apicreateinfo");
          });
      } else if (UserDetails?.broker === "4") {
        dispatch(ZebPayBrokerProfile_Info(data))
          .unwrap()
          .then((data) => {
            if (data.status) {
              Swal.fire({
                title: "Success!",
                text: "Broker connected successfully.",
                icon: "success",
                confirmButtonText: "OK",
                timer: "3000",
              });
              fetchUserProfile();
            }
          })
          .catch((err) => {
            navigate("/client/apicreateinfo");
          });
      } else if (UserDetails?.broker === "5") {
        dispatch(Broker_Coinswitch_Wallet(data))
          .unwrap()
          .then((data) => {
            if (data.status) {
              Swal.fire({
                title: "Success!",
                text: "Broker connected successfully.",
                icon: "success",
                confirmButtonText: "OK",
                timer: "3000",
              });
              fetchUserProfile();
            } else {
              Swal.fire({
                title: "Error!",
                text: data.message,
                icon: "error",
                confirmButtonText: "OK",
              });
              navigate("/client/apicreateinfo");
            }
          })
          .catch((err) => {
            navigate("/client/apicreateinfo");
          });
      } else {
        navigate("/client/apicreateinfo");

      }

    }
  };

  // Redirect to admin page
  const redirectToAdmin = () => {
    const targetPath = page ? `/admin/${page}` : routePath;

    navigate(targetPath);
    localStorage.removeItem("page");
    localStorage.removeItem("gotodashboard");
    localStorage.removeItem("user_details_goTo");
    localStorage.removeItem("user_role_goTo");
    localStorage.removeItem("route");
  };


  // 21/01/2024: 

  const startStatusPolling = () => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    pollingIntervalRef.current = setInterval(async () => {
      await checkUserStatus();
    }, 30000);
  };


  const checkUserStatus = async () => {
    try {
      const userId = gotodashboard
        ? UserNamego_localstg.user_id
        : user_details.user_id;
      const token = gotodashboard
        ? UserNamego_localstg.token
        : user_details.token;

      const response = await dispatch(
        User_Profile({ id: userId, token: token })
      ).unwrap();

      if (response.status) {
        const userData = response.data[0];


        // if (userData.WebLoginStatus === "0") {
        //   await handleForceLogout("Your session has been ended by the system.");
        //   return;
        // }


        if ((userData.TradingStatus === "0") && userData.WebLoginStatus === "0") {
          await handleForceLogout("Your trading has been turned off by the system.");
          return;
        }


        if (userData.ActiveStatus === "0") {
          await handleForceLogout("Your account has been deactivated.");
          return;
        }


        setUserDetails(userData);
      } else {

        if (
          response.msg === "Unauthorized!" ||
          response.msg === "No token provided!!"
        ) {
          await handleForceLogout("Session expired. Please login again.");
        }
      }
    } catch (error) {
      console.error("Error checking user status:", error);
    }
  };


  const handleForceLogout = async (message) => {
    try {

      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }


      Swal.fire({
        icon: "warning",
        title: "Session Ended",
        text: message,
        showConfirmButton: true,
        allowOutsideClick: false,
      }).then(async () => {
        // Logout API call
        const request = {
          userId: user_details.user_id,
          Device: "web",
        };

        await dispatch(Log_Out_User(request));


        localStorage.clear();


        navigate("/");
      });
    } catch (error) {
      console.error("Error during force logout:", error);
      localStorage.clear();
      navigate("/");
    }
  };


  return (
    <div className="header-container">
      <div className="header" style={{ position: "fixed" }}>
        <div className="header-content">
          <Logo />
          <nav className="navbar navbar-expand">
            <div className="collapse navbar-collapse justify-content-between">
              <div className="header-left"></div>

              <ul className="navbar-nav header-right align-items-center">
                {/* Go to Admin Button */}
                {gotodashboard && (
                  <li className="nav-item">
                    <button
                      onClick={redirectToAdmin}
                      type="button"
                      className="btn btn-primary text-white me-2"
                    >
                      Go to Admin
                    </button>
                  </li>
                )}

                <li className="nav-item me-2" style={{ listStyle: 'none' }}>
                  <button
                    type="button"
                    className={`btn btn-primary d-flex align-items-center gap-2 rounded-pill shadow-sm ${isCapturing ? 'opacity-75' : ''}`}
                    onClick={handleRaiseTicket}
                    disabled={isCapturing}
                    title="Raise Ticket"
                    style={{ fontSize: '13px', padding: '8px 16px', fontWeight: '500' }}
                  >
                    {isCapturing ? (
                      <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Capturing...</>
                    ) : (
                      <><i className="fa fa-bug" aria-hidden="true"></i> Raise Ticket</>
                    )}
                  </button>
                </li>


                {/* Trading Status Button */}
                {user_role === "USER" && UserDetails?.license_type !== "1" && (
                  <li className="nav-item">
                    <div
                      onClick={() => Trading_status_off(UserDetails?.TradingStatus)}
                      className="trading-toggle"
                      title={`Trading is ${UserDetails?.TradingStatus === "1" ? "ON" : "OFF"
                        }`}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: "pointer",
                        borderRadius: "999px",
                        padding: "4px 8px",
                        backgroundColor:
                          UserDetails?.TradingStatus === "1"
                            ? "#33B46933"
                            : "#FF5C5C33",
                        border: `2px solid ${UserDetails?.TradingStatus === "1"
                          ? "#33B469"
                          : "#FF5C5C"
                          }`,
                        transition: "all 0.3s ease",
                        userSelect: "none",
                      }}
                    >
                      <div
                        className="trading-toggle-circle"
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          backgroundColor:
                            UserDetails?.TradingStatus === "1"
                              ? "#33B469"
                              : "#FF5C5C",
                          transition: "all 0.3s ease",
                          marginRight: "8px",
                        }}
                      ></div>

                      <span
                        className="trading-toggle-text"
                        style={{
                          fontWeight: "600",
                          color:
                            UserDetails?.TradingStatus === "1"
                              ? "#33B469"
                              : "#FF5C5C",
                          fontSize: "14px",
                        }}
                      >
                        {UserDetails?.TradingStatus === "1"
                          ? "Trading On"
                          : "Trading Off"}
                      </span>
                    </div>
                  </li>
                )}

                {user_role === "USER" &&
                  UserDetails?.trading_expiry === "default_off" && (
                    <li className="nav-item">
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          padding: "6px 12px",
                          borderRadius: "999px",
                          backgroundColor: "#FFE5E5",
                          border: "2px solid #FF5C5C",
                          color: "#FF5C5C",
                          fontWeight: "600",
                          fontSize: "13px",
                        }}
                        title="Trading is disabled by default settings"
                      >
                        Trading Off (Default)
                      </div>
                    </li>
                  )}



                {/* Notifications */}
                {user_role === "ADMIN" && (
                  <li className="nav-item">
                    <Notification status="1" NotificationData={getAllClients} />
                  </li>
                )}


                <div className="profile-card profile-card-hide shadow-sm p-2 rounded me-2 ms-2">
                  <li
                    className="nav-item header-profile d-flex align-items-center gap-2 profile-tooltip"
                    data-username={UserDetails?.FullName}
                  >
                    <div className="d-flex align-items-center">
                      {/* <div
                        className="rounded-circle me-2"
                        style={{
                          width: "38px",
                          height: "38px",
                          backgroundColor: "#e9ecef",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontWeight: "600",
                          color: "#495057",
                          fontSize: "16px",
                        }}
                      >
                        {UserDetails?.FullName?.charAt(0)}
                      </div> */}

                      <div>
                        <h6 style={{ margin: 0, fontSize: "14px", fontWeight: "600" }}>
                          {UserDetails?.UserName || ""}
                        </h6>
                        {/* <p style={{ margin: 0, fontSize: "12px", color: "#6c757d" }}>
          {UserDetails?.Role === "ADMIN" ? "Administrator" : "User"}
        </p> */}
                      </div>
                    </div>
                  </li>
                </div>


                {user_role === "USER" && (
                  <li className="nav-item">
                    <Notification status="2" NotificationData={messageData} />
                  </li>
                )}


                {/* User Profile Dropdown */}

                <li
                  className="nav-item header-profile d-flex align-items-center gap-2 profile-tooltip"
                  data-username={UserDetails?.FullName}
                >
                  <DropDown
                    avatar={avatar}
                    onAvatarChange={handleAvatarChange}
                    userName={UserDetails?.FullName}
                  />
                </li>
              </ul>
            </div>
          </nav>


          {/* Chat Icon Button */}
          <li className="nav-item">
            <button
              type="button"
              className=" botIcon"
              onClick={() => setShowChat(true)}
              title="Open Chat"
            >
              <i className=" fa fa-commenting	" aria-hidden="true"></i>
            </button>
          </li>
        </div>
      </div>

      {/* Chatbot Component */}
      {showChat && <Chatbot onClose={() => setShowChat(false)} />}

      <GlobalBugReportModal isOpen={isBugModalOpen} onClose={() => setIsBugModalOpen(false)} capturedImage={capturedImage} />

      {/* Toast Notifications */}
      <ToastButton />
    </div>
  );
};

export default Header;
